import Flickity from 'flickity';
import { throttle } from '../util/utils';


const flickityClass = 'f-carousel';
const baseClass = 'section-locations_showcase-carousel';
const cellClass = `${baseClass}__cell`;
const sectionClass = 'section-locations_showcase';


const LocationsShowcase = (() => {
	const c = {
		instances: [],
		cellsPerSlide: 1,
	}

	c.init = function() {
		const sections = Array.from(document.querySelectorAll(`.${sectionClass}`));
		if (!sections.length) {
			return;
		}

		sections.forEach(rootElem => {
			c.initTabs(rootElem);

			const carouselRoot = rootElem.querySelector(`.${baseClass}`);
			const carousel = c.initCarousel(carouselRoot);
			if (carousel) {
				c.instances.push(carousel);
			}
		});


		// window.addEventListener('load', c.resizeInstances, {once: true});
		// window.addEventListener('DOMContentLoaded', c.resizeInstances, {once: true});

		// //TODO: debounce this
		// window.addEventListener('resize', c.handleWindowResize);
	}


	c.initCarousel = function(root) {
		const config = {
			cellSelector: `.${cellClass}`,
			groupCells: false,
			pageDots: false,
			accessibility: true,
			prevNextButtons: false,
			cellAlign: 'left',
			adaptiveHeight: false,
			draggable: true,
			wrapAround: false,
			contain: true,
			freeScroll: true,
			on: {
				staticClick: function(e) {
					// re-enable swup for this link by the time it's event
					// is received by jquery
					if (e.target.hasAttribute('data-no-swup')) {
						e.target.removeAttribute('data-no-swup');
					}
				},
			},
		}

		const instance = new Flickity(root, config);

		c.attachControls(instance);

		return instance;
	}

	c.attachControls = function(instance) {
		if (!instance || !instance.element) {
			return;
		}

		const section = instance.element.closest(`.${sectionClass}`);
		if (!section) {
			return;
		}

		const prevBtn = section.querySelector(`.${sectionClass}__carousel-prev`);
		const nextBtn = section.querySelector(`.${sectionClass}__carousel-next`);

		prevBtn.addEventListener('click', () => {
			instance.previous();
		});

		nextBtn.addEventListener('click', () => {
			instance.next();
		});

		const progressBar = section.querySelector(`.${sectionClass}__carousel-progress`);
		if (!progressBar) {
			return;
		}

		progressBar.style.setProperty('--progress', '0%');

		instance.on('scroll', throttle((progress) => {
			progress *= 100;

			if (progress < 0) {
				progress = 0;
			}
			else if (progress > 100) {
				progress = 100;
			}

			progressBar.style.setProperty('--progress', progress + '%');
		}, 32));
	}

	c.initTabs = function(root) {
		root.addEventListener('click', (e) => {
			const isTab = e.target.hasAttribute('role') && e.target.getAttribute('role') === 'tab';
			if (!isTab) {
				return;
			}

			const clicked = e.target;
			const tabId = clicked.getAttribute('aria-controls');

			const allTabs = root.querySelectorAll('[role="tab"]');
			const allPanels = root.querySelectorAll('[role="tabpanel"]');

			allTabs.forEach(tab => {
				if (tab.hasAttribute('aria-controls') && tab.getAttribute('aria-controls') === tabId) {
					tab.setAttribute('aria-selected', true);
				}
				else {
					tab.setAttribute('aria-selected', false);
				}
			});

			allPanels.forEach(panel => {
				if (panel.id === tabId) {
					panel.setAttribute('aria-hidden', 'false');
				}
				else {
					panel.setAttribute('aria-hidden', 'true');
				}
			});
		});
	}

	c.handleWindowResize = function(e) {
		// const newCellsPerSlide = calcCellsPerSlide();
		// if (newCellsPerSlide !== c.cellsPerSlide) {
		// 	c.refreshInstances();
		// }
	}

	c.refreshInstances = function() {
		c.instances = c.instances.map(oldInstance => {
			const rootElem = oldInstance.element;
			oldInstance.destroy();

			const newInstance = c.initCarousel(rootElem);

			return newInstance;
		})
		.filter(instance => !!instance);
	}

	c.resizeInstances = function() {
		c.instances.forEach(instance => {
			instance.resize();
		})
	}


	return c;
})();


export default LocationsShowcase;



// WEBPACK FOOTER //
// ./scripts/modules/locations-showcase.js